import { Component, Inject, InjectionToken, NgZone, ViewChild } from '@angular/core';
import { getCurrencySymbol } from "@angular/common";
import { IonicPage, NavController, NavParams, Platform, Content } from 'ionic-angular';
import { CustomersProvider } from '../../providers/myria/customer-provider/customers-provider';
import { SendFlowProvider } from '../../providers/send-flow/send-flow';
import { ORDER_STATUS, RecentData, Transaction, TRANSACTION_CATEGORY_TYPE, TransactionViewType } from '../../model/myria/app/transaction';
import { OrderProvider } from '../../providers/order/order';
import { RouteProvider } from '../../providers/route/route';
import { PaymentMethodTypeID } from '../../model/types/payment-method-type';
import { SegmentProvider } from '../../providers/analytics/segment';
import { AnalyticsEventType, AnalyticsProfileCreationStartedLocations, SegmentLocationNames, UserLoggingStatus } from '../../model/types/analytics.const';
import { IOrder } from '../../model/models/order/order-interface';
import { OnfidoProvider } from '../../providers/myria/onfido-provider';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { ConfigProvider } from '../../providers/config/config';
import { ICustomer } from '../../model/models/customer';
import { LoginProvider } from '../../providers/myria/login-provider';
import { ALERT_TYPE, COUNTRY_SETTINGS, CUSTOMER_SETTINGS, KYC_ATTEMPT_STATUS, KYC_STATUS, KYC_METHODS, EKYC_PROCESSOR_TYPE, PROMOTION_TYPE } from '../../providers/myria/app-variables';
import { CustomerProvider } from '../../providers/customer/customer';
import { AuthProvider } from '../../providers/authorization/auth';
import { TranslateService } from "@ngx-translate/core";
import { IOrderPendingEntity } from '../../model/api/order/order-pending.entity.interface';
import { LoadingProvider } from '../../providers/loading/loading';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { DeeplinkProvider } from '../../providers/marketing/deeplink';
import { WalletProvider } from "../../providers/wallet/wallet";
import { IterableProvider } from "../../providers/marketing/iterable";
import { IterableInAppProvider } from '../../providers/marketing/iterable-inapp';
import { HttpProvider } from '../../providers/http/http';
import { APP_CONFIG, Region } from '../../environment';
import { ResourceProvider } from '../../providers/resource/resource';
import { FeatureFlagTypes, UtilsProvider } from '../../providers/myria/utils-provider';
import { PlaidProvider } from '../../providers/plaid/plaid';
import { PaymentProvider } from '../../providers/payment/payment';
import { RmtSnackbarComponent } from '../../components/rmt-snackbar/rmt-snackbar';
import { ProfileNotification } from '../../model/types/profile-notification-type';
import { ProfileNotificationProvider } from '../../providers/profile-notification/profile-notification';
import { RegisterProvider } from '../../providers/register/register';
import { ChatProvider } from '../../providers/zendesk/chat';
import { InAppMessage } from 'model/api/iterables/iterables-inapp-response.entity.interface';
import { RmtSlides } from '../../components/rmt-slides/rmt-slides';
import { RecipientProvider } from '../../providers/recipient/recipient';
import { DeliveryMethodType } from '../../model/types/delivery-method-type';
import { StorageProvider } from '../../providers/storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { OrderMapper } from '../../providers/order/order.mapper';
import { PriceCalculatorProvider } from '../../providers/price-calculator/price-calculator';
import { HomeScreenProvider } from '../../providers/homescreen/homescreen';
import { EkycSingPassProvider } from '../../providers/ekyc-singpass/ekyc-singpass';
import { ReminderProvider } from '../../providers/reminder-provider/reminder-provider';
import { User } from "../../model/myria/app/user";
import { EKYC_PAGEFROM } from "../../model/models/ekyc-singpass/ekyc-singpass.model";
import { VueProvider } from '../../providers/vue/vue';
import { VueBridgeState } from '../../providers/vue/vue-helpers';
import { SocialProvider } from '../../providers/social/social';
import { NumberFormatter } from '../../pipes/currency-pipe';
import { HomeRevamp } from '../../providers/homescreen/home-revamp';
import { homeTranslate } from '../../providers/homescreen/home-revamp-translate';
import { IHomeCorridorPreset, IHomeRateOption } from '../../model/types/home-revamp-types';
import { DingTopUpProvider } from '../../providers/ding-top-up/ding-top-up';
import { DING_TOP_UP_BANNER_ANALYTICS } from '../../model/types/ding-top-up.const';


export enum SLIDE_TYPE_ID {
  SLIDE_ACTIVATE_WALLET = 1,
  SLIDE_FPX_TRX = 2,
  SLIDE_REQUIRE_PHONE_VERIFICATION = 3,
  SLIDE_STORED_ORDER = 4,
  SLIDE_ID_VERIFICATION = 5,
  SLIDE_COMPLETE_PROFILE = 6,
  //SLIDE_TYPE_ID_ = 7, // TODO can be removed ? unused
  SLIDE_CUSTOMER_ID_INVALID = 8,
  SLIDE_PREPAID_CARD = 9,
  TRANSFERS_RESTRICTED = 10,
  SLIDE_BIOMETRIC_REMINDER = 11,
  SLIDE_PENDING_LITE_WALLET = 12,
  SLIDE_INPROGRESS_LITE_WALLET = 13,
  SLIDE_IMPORTANT_LITE_WALLET = 14,
  SLIDE_PENDING_TRANX = 15,
  SLIDE_EXPIRED_ORDER = 16,
  SLIDE_ID_PRE_EXPIRY = 17,
  SLIDE_MOBILE_TOP_UP = 18
};

export const HOME_RATE_CALCULATOR = new InjectionToken<PriceCalculatorProvider>('HomeRateCalculator');

@IonicPage()
@Component({
  selector: 'page-activity',
  templateUrl: 'activity.html',
  providers: [{ provide: HOME_RATE_CALCULATOR, useClass: PriceCalculatorProvider }],
})
export class ActivityPage {
  @ViewChild('header') header;
  @ViewChild('slidesMessagesComponent') slidesMessagesComponent;
  @ViewChild('slidesRecipientsComponent') slidesRecipientsComponent;
  @ViewChild(Content) content: Content;
  animLoading = true;
  animLoadingSlide = false;
  currentPage: number = 0;
  isLoading: boolean = true; // show loading only the first time - other refreshes are done in the background
  hasTransactions: boolean = false;
  newOrderNumber;
  entered: boolean = true;
  storedOrder: IOrder;
  onfidoFinished: any = null;
  onfidoTimer;

  allTransactions: Transaction[] = [];
  inProgressTransactions: Transaction[] = [];
  otherTransactions: Transaction[] = [];
  newTransaction: Transaction = null;
  showTransferStatusWidget: boolean = false;
  requirePhoneVerification: boolean;

  displaySuspectedAlert: boolean = false;
  suspectedAlertMessage: string = '';
  showRightProfile: boolean = false;
  isShowActivateWalletPopup: boolean = false;
  isShowNonFPXPopup: boolean = false;
  firstKycStatus: boolean = true;
  kycAttemtsRemaining: boolean = true;

  canShowModalReferralPage: boolean = true;
  onBellClick: any;
  onChatClick: any;
  isCustomerIDInvalid: boolean = false;
  isSingpassEnabled: boolean = false;
  isKycInProgress: boolean = false;
  transactionFilterEnabled: boolean = false;
  promoAvailable: boolean = false;
  isFromSettings: boolean = false;
  pendingOrder = null;

  deepLinkData;
  hasInAppMessages: boolean = false;
  inAppMessages: InAppMessage[] = [];
  recentData = new RecentData();
  recentDataTime = null;
  loadingRecentView;

  ProfileNotificationProvider = ProfileNotificationProvider;
  ionScrollSubscription;
  onReferAFriendClick:any;
  isUserProfileCompleted: boolean = true;
  referAFriendAvailable: boolean = false;
  walletEnabled: boolean = false;
  referralReward: string = "";
  carouselAlertsAdded: boolean = false;
  showMessages: boolean = false;
  showRecentView: boolean = false;
  showRecentRate: boolean = false;
  showViewAllButton: boolean = false;
  clickSlideClose: any;
  lockedScroll: boolean = false;
  initializedView;
  currentRate: number;
  rateLastTransactionCountryTo: string;
  rateLastTransactionCurrencyFrom: string;
  rateLastTransactionCurrencyTo: string;
  isWalletCountry: boolean = false;

  recentCountry;
  recentCurrency;
  recentRate;
  loadingRate = true;
  reminderBiometricStatus = false;
  showMobileTopUpSlide = false;
  mobileTopUpSlideTracked = false;
  bridgeVisibleSubscription;
  npsSurveyPrompted = false;
  lastReload;
  transactionsCanChange = true;

  selectTransactionFiltered;
  renderPendingOrderDetails: boolean = false;
  user: User = null;
  pendingOrderMessage = '';
  pendingOrderEkycTitle = '';
  rate: number = null;
  ratePromo: number = null;
  order: IOrder = {};
  isWelcomeRate: boolean = false;
  welcomeRateInitialized: boolean = false;
  isDigitalIDVerificationCountry: boolean = false;
  isVeriffVerified: boolean = false;

  rmt5VueBridgeSettings: boolean = true;
  homeRevampFlag: boolean = false;
  countryToName: string = '';
  countryFromName: string = '';
  homeLocale: string = '';
  openedFromSettings: boolean = false;
  heroImage: string = '';
  heroTitleLead: string = '';
  heroSubtitleHtml: string = '';
  heroInitials: string = '';
  homeRevampHeaderHidden: boolean = false;
  heroPullOffset: number = 0;
  homePartners: IHomeCorridorPreset = null;
  homeRateLoading: boolean = false;
  homeRateError: boolean = false;
  homeDestinationRefreshing: boolean = false;
  homeEntered: boolean = false;
  homeTransferCompleted: boolean = false;
  homeRateOptions: IHomeRateOption[] = [];
  homeRateOptionsSeq: number = 0;
  homeRatePrimarySeq: number = 0;
  homeRateOptionsRequestedSeq: number = 0;

  get homeRevampActive(): boolean {
    return this.homeRevampFlag && !this.openedFromSettings && !this.hasTransactions && !this.homeTransferCompleted && !this.animLoading;
  }

  // The in-progress carousel only renders in the recent view, so other views fall back to the unified list
  get useTransferStatusWidgetLayout(): boolean {
    return this.showTransferStatusWidget && this.showRecentView;
  }

  get heroRewardLabel(): string {
    return this.referralReward
      ? this.translate.instant('page.rAFPage.rAFHeaderDynamic', { referralReward: this.referralReward })
      : this.translate.instant('page.rAFPage.rAFHeaderNew');
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private customerProvider: CustomersProvider,
    private orderProvider: OrderProvider,
    private routeProvider: RouteProvider,
    private onfidoProvider: OnfidoProvider,
    private loginProvider: LoginProvider,
    private analytics: SegmentProvider,
    private custProvider: CustomerProvider,
    private loading: LoadingProvider,
    private authProvider: AuthProvider,
    private sendFlowProvider: SendFlowProvider,
    private deeplinkProvider: DeeplinkProvider,
    private loadingProvider: LoadingProvider,
    private walletProvider: WalletProvider,
    private iterable: IterableProvider,
    private platform: Platform,
    private iterableInAppProvider : IterableInAppProvider,
    private resourceProvider: ResourceProvider,
    private httpProvider: HttpProvider,
    private utilsProvider: UtilsProvider,
    private plaidProvider: PlaidProvider,
    private storageProvider: StorageProvider,
    private paymentProvider: PaymentProvider,
    private registerProvider: RegisterProvider,
    private chatProvider: ChatProvider,
    private recipientProvider: RecipientProvider,
    private calcProvider: PriceCalculatorProvider,
    private homescreenProvider: HomeScreenProvider,
    private vueProvider: VueProvider,
    private ekycSingPassProvider: EkycSingPassProvider,
    private reminderProvider: ReminderProvider,
    private socialProvider: SocialProvider,
    private currencyFormatter: NumberFormatter,
    private dingTopUpProvider: DingTopUpProvider,
    @Inject(HOME_RATE_CALCULATOR) private homeRateCalculator: PriceCalculatorProvider,
    private zone: NgZone,
  ) {
    this.canShowModalReferralPage = true;
    this.openedFromSettings = !!this.navParams.get('isFromSettings');
    const order = this.orderProvider.getCurrentOrder();
    this.markHomeTransferCompleted(order);
    if (order && order.newOrder) {
      this.newOrderNumber = order.orderNumber;
      order.newOrder = false;
    }
    this.onBellClick = () => this.iterableInAppProvider.openMobilAppInbox(this.header, 'activity');
    this.onChatClick = () => this.chatProvider.clickChatbot();
    this.onReferAFriendClick = () => this.onReferAFriend();
    this.clickSlideClose = (slideMessage) => this.clickCloseSlide(slideMessage);
    this.selectTransactionFiltered = (transaction, index) => this.onSelectTransaction(transaction, index);
    this.isWalletCountry = (APP_CONFIG.region.region === Region.MY);
  }

  async initView() {
    //To ensure that we not enable new home screen for regions where it's set to false
    if(APP_CONFIG.region.showNewHomePage) {
      this.showMessages = APP_CONFIG.region.showNewHomePage && APP_CONFIG.featureFlags.showNewHomePage;//await this.utilsProvider.hasFeatureFlag(FeatureFlagTypes.HomescreenShowCarrousel);
      this.showRecentView = APP_CONFIG.region.showNewHomePage && APP_CONFIG.featureFlags.showNewHomePage; //await this.utilsProvider.hasFeatureFlag(FeatureFlagTypes.HomescreenShowRecentView);
      // this.showRecentRate = true; //await this.utilsProvider.hasFeatureFlag(FeatureFlagTypes.HomescreenShowRecentRate);
    }

    // preload data for new view as soon as possible
    if (this.showRecentView) {
      this.animLoadingSlide = true;
      this.initRecentView(false, true);
    }
    this.getRecentRate();
  }

  async getAppMessages() {
    const inAppMessages: InAppMessage[] = await this.iterableInAppProvider.getAppActivityMessages(RmtSlides);

    this.showViewAllButton = (inAppMessages && inAppMessages.length > 1) || this.iterableInAppProvider.getMessagegNonPriorityViewAllBtn();
    this.updateSlideMessages(inAppMessages)
  }

  removeInAppMessagesFromCarousel(filterInAppMessages) {
    return filterInAppMessages.filter(item => (item.messageId == undefined || item.messageId == null));
  }

  //TODO: check slide messages
  async updateSlideMessages(filterInAppMessages) {
    if (filterInAppMessages) {
      this.hasInAppMessages = filterInAppMessages.length > 0;
      this.inAppMessages = filterInAppMessages;
    }
    let slidesMessages = [];

    slidesMessages = [ ...this.inAppMessages ];

    await this.updateCarouselWithAlert(slidesMessages);
    if (this.checkUpdateSlides(this.recentData.slidesMessages, slidesMessages)) {
      this.recentData.slidesMessages = slidesMessages;
      if (this.slidesMessagesComponent)
        this.slidesMessagesComponent.updateSwiper();
    }
    this.storeRecentData();
  }

  get isIdExpiredAlertAllowedSg(): boolean {
    if (APP_CONFIG.region.region !== Region.SG)
      return true;
    return this.isSingpassEnabled && this.kycAttemtsRemaining;
  }

  async updateCarouselWithAlert(slidesMessages) {
    this.carouselAlertsAdded = true;

    if (this.showMobileTopUpSlide) {
      const mobileTopUpMessage = {
        id: SLIDE_TYPE_ID.SLIDE_MOBILE_TOP_UP,
        alertType: ALERT_TYPE.ALERT_INFO,
        image: 'assets/imgs/mobile_top_up_carousel.svg',
        title: this.translate.instant('global.mainNavigation.more.mobileTopUps'),
        subtitle: this.translate.instant('page.home.mobileTopUpBanner.title'),
        isClosable: true,
        actionButton: true,
        buttonText: this.translate.instant('page.home.mobileTopUpBanner.ctaButton')
      };
      this.addToSlideMessages(mobileTopUpMessage, slidesMessages);
    }

    if (this.isShowNonFPXPopup) {
      const fpsTransactionMessage = {
        id: SLIDE_TYPE_ID.SLIDE_FPX_TRX,
        alertType: ALERT_TYPE.ALERT_INFO,
        titleKey: 'page.activityPage.fpxTransactionHeader',
        title: this.translate.instant('page.activityPage.fpxTransactionHeader'),
        subtitle: this.translate.instant('page.activityPage.fpxTransactionBody'),
        pendingLabel: true,
        actionButton: true,
        isHtmlText: true,
        buttonText: this.translate.instant('page.activityPage.activateWalletAlertButton')
      }
      this.addToSlideMessages(fpsTransactionMessage, slidesMessages)
    }

    if (!this.isUserProfileCompleted) {
        const userProfileCompletedMessage = {
          id: SLIDE_TYPE_ID.SLIDE_COMPLETE_PROFILE,
          alertType: ALERT_TYPE.ALERT_INFO,
          titleKey: 'page.activityPage.liteRegAlert',
          title: this.translate.instant('page.activityPage.liteRegAlert'),
          pendingLabel: true,
          actionButton: true,
          buttonText: this.translate.instant('global.getStartedButton')
        }
        this.addToSlideMessages(userProfileCompletedMessage, slidesMessages)
    }

    if(this.reminderBiometricStatus) {
      const reminderMessage = {
        id: SLIDE_TYPE_ID.SLIDE_BIOMETRIC_REMINDER,
        alertType: ALERT_TYPE.ALERT_SHIELD,
        titleKey: 'page.homePage.biometricReminderTitle',
        title: this.translate.instant('page.homePage.biometricReminderTitle'),
        subtitle: this.translate.instant('page.homePage.biometricReminderBody'),
        isClosable: true,
        actionButton: true,
        buttonText: this.translate.instant('global.myRia.jsonContent.setUpNowCTA')
      }
      this.addToSlideMessages(reminderMessage, slidesMessages)
    }

    if (this.isCustomerIDInvalid && !this.isKycInProgress && (!this.isDigitalIDVerificationCountry || this.isVeriffVerified) && this.isIdExpiredAlertAllowedSg) {
      const CustomerIDInvalidMessage = {
        id: SLIDE_TYPE_ID.SLIDE_CUSTOMER_ID_INVALID,
        alertType: ALERT_TYPE.ALERT_ERROR,
        titleKey: 'page.sendFailedPage.iDExpiredHeader',
        title: this.translate.instant('page.sendFailedPage.iDExpiredHeader'),
        pendingLabel: true,
        actionButton: true,
        buttonText: this.translate.instant('page.preLoginPage.updateButton')
      }
      this.addToSlideMessages(CustomerIDInvalidMessage, slidesMessages)
    }

    if (this.requirePhoneVerification) {
      const requirePhoneVerificationMessage = {
        id: SLIDE_TYPE_ID.SLIDE_REQUIRE_PHONE_VERIFICATION,
        alertType: ALERT_TYPE.ALERT_WARNING,
        titleKey: 'page.activityPage.verifyPhoneNumberMessage',
        title: this.translate.instant('page.activityPage.verifyPhoneNumberMessage'),
        pendingLabel: true,
        actionButton: true,
        buttonText: this.translate.instant('global.myRia.jsonContent.Verify')
      }
      this.addToSlideMessages(requirePhoneVerificationMessage, slidesMessages)
    }

    if (this.storedOrder && this.storedOrder.activityDetails && !this.onfidoFinished) {
      const onfidoNotFinishedMessage = {
        id: SLIDE_TYPE_ID.SLIDE_STORED_ORDER,
        alertType: ALERT_TYPE.ALERT_WARNING,
        titleKey: this.storedOrder.activityDetails.title,
        title: this.translate.instant(this.storedOrder.activityDetails.title),
        subtitle: this.translate.instant(this.storedOrder.activityDetails.text),
        pendingLabel: true,
        actionButton: true,
        buttonText: this.translate.instant('page.sendReceiptPage.title')
      }
      this.addToSlideMessages(onfidoNotFinishedMessage, slidesMessages);
    }

    if (this.storedOrder && this.storedOrder.activityDetails && this.onfidoFinished) {
      const onfidoFinishedMessage = {
        id: SLIDE_TYPE_ID.SLIDE_ID_VERIFICATION,
        alertType: ALERT_TYPE.ALERT_SUCCESS,
        titleKey: 'page.activityPage.iDVerificationCompleteHeader',
        title: this.translate.instant('page.activityPage.iDVerificationCompleteHeader'),
        pendingLabel: false,
        actionButton: true,
        buttonText: this.translate.instant('page.activityPage.iDVerificationCompleteContent')
      }
      this.addToSlideMessages(onfidoFinishedMessage, slidesMessages);
    }

    if (this.isShowActivateWalletPopup) {
      const activateWalletMessage = {
        id: SLIDE_TYPE_ID.SLIDE_ACTIVATE_WALLET,
        alertType: ALERT_TYPE.ALERT_WARNING,
        titleKey: 'page.activityPage.activateWalletAlertHeader',
        title: this.translate.instant('page.activityPage.activateWalletAlertHeader'),
        subtitle: this.translate.instant('page.activityPage.activateWalletAlertContent'),
        pendingLabel: true,
        actionButton: true,
        buttonText: this.translate.instant('page.activityPage.activateWalletAlertButton')
      };
      this.addToSlideMessages(activateWalletMessage, slidesMessages);
    }

    if (this.loginProvider.isUserFraudBlocked()) {
      const transfersRestrictedMessage = {
        id: SLIDE_TYPE_ID.TRANSFERS_RESTRICTED,
        alertType: ALERT_TYPE.ALERT_ERROR,
        titleKey: 'Page.accountLocked.transferRestrictedBannerHeader',
        title: this.translate.instant('Page.accountLocked.transferRestrictedBannerHeader'),
        subtitle: this.translate.instant('Page.accountLocked.transferRestrictedBannerDescription'),
        actionButton: true,
        buttonText: this.translate.instant('Page.accountLocked.renableTransfersButton')
      };
      this.addToSlideMessages(transfersRestrictedMessage, slidesMessages);
    }

    // if (this.isCustomerIDInvalid) {
    //   slidesMessages.unshift(
    //     {
    //       id: SLIDE_TYPE_ID.SLIDE_CUSTOMER_ID_INVALID,
    //       alertType: ALERT_TYPE.ALERT_ERROR,
    //       title: this.translate.instant('page.sendFailedPage.iDExpiredHeader'),
    //       pendingLabel: true,
    //       actionButton: true,
    //       buttonText: this.translate.instant('page.preLoginPage.updateButton')
    //     }
    //   );
    // }

  }

  async addToSlideMessages(newSlideMessage: any, slidesMessages) {
    const existingItem = slidesMessages.find(item => item.id === newSlideMessage.id);

    if (!existingItem) {
      slidesMessages.unshift(newSlideMessage);
    } else if (existingItem && existingItem.title !== newSlideMessage.title) {
      const pos = slidesMessages.map(item => item.id).indexOf(newSlideMessage.id);
      slidesMessages[pos] = newSlideMessage;
    } else {
      console.log(`Item with id ${newSlideMessage.id} already exists.`);
    }
  }

  async ionViewWillEnter() {
    // Server flag is the real gate; the APP_CONFIG value is a QA override only reachable from the debug menu, so it is honored only in debug builds.
    this.showTransferStatusWidget = (await this.utilsProvider.getFeatureFlagData(FeatureFlagTypes.TransferStatusWidgetEnabled)) === true
      || (APP_CONFIG.showDebug && APP_CONFIG.showTransferStatusWidget);
    this.initializedView = this.initView();
    this.markHomeTransferCompleted(this.orderProvider.getCurrentOrder());
    this.checkPendingOrder();
    await this.initPage();
    this.homeEntered = true;
    this.refreshHomeRevampDestination();
    this.entered = true;
    const fetchPendingDetails = null;
    try {
      const pendingOrderDetails = await this.walletProvider.fetchPendingOrderDetails();
      if (pendingOrderDetails) {
        this.pendingOrderMessage = pendingOrderDetails.pendingOrderMessage;
        this.pendingOrderEkycTitle = pendingOrderDetails.pendingOrderEkycTitle;
        this.renderPendingOrderDetails = pendingOrderDetails.renderPendingOrderDetails;
      }
    } catch (err) {
      LoggerProvider.exception(this, err, LoggerEvent.ActivityPage, 'Failed to fetch pending details.');
    }

    if (!this.vueProvider.isRmt5HomeActiveBaseLayer()) {
      this.homescreenProvider.trackHomeScreenOrActivityAccessedEvent(
        SegmentLocationNames.Activity, this.hasInAppMessages);
    }

    if (!this.showRecentView) {
      this.animLoading = false;
      this.triggerHomeRateOptions();
    }

    this.authProvider.endLoginProfiler();

    if(AuthProvider.isLoggedIn()) this.checkStatusKyc();
    if(this.canShowModalReferralPage) this.checkReferralFlow();

    // OM-15924 | Get user info only only once and use it everywhere in the page
    this.user = await this.loginProvider.getUserAsync();
    this.updateHeroInitials();

    if(
      this.walletProvider.Enabled &&
      this.walletProvider.hasWallet() === false
    ){
      const isSandBoxAvailable = await this.walletProvider.isSandBoxAvailable();
      const canTransact = await this.walletProvider.isUserCanTransact();
      if (this.isUserVerified(this.user) || isSandBoxAvailable)
        await this.loadActivateWalletPopup();
      else if (canTransact && !isSandBoxAvailable)
        await this.loadNonFPXPopup();
    }
    this.checkPhoneVerification();
    try {
      await Promise.all([fetchPendingDetails]);
    } catch (err) {
      LoggerProvider.exception(this, err, LoggerEvent.ActivityPage, "Failed to fetch pending details.");
    }
  }

  ionViewDidEnter(){
    this.walletProvider.isSelectingTransaction = false;
    this.deepLinkData = DeeplinkProvider.deepLinkData;
    this.trackMobileTopUpSlideDisplayed();

    setTimeout(()=>this.checkPlaidPostedAccount(), 1000); // to work around the case that there is a modal already open that will dismiss this modal while dismissing itself
    const resendUnknownError = this.navParams.get('resendUnknownError');
    if (resendUnknownError) {
      this.openResendUnknowErrorModal();
    }
    this.loginProvider.getUserAsync(true).then(user => {
      if(user && user.IsProfileCompleted != undefined){
          this.isUserProfileCompleted = user.IsProfileCompleted;
          this.updateSlideMessages([]);
      }

      // check refer a friend setting after update profile

      if (this.loginProvider.showFraudRestriction && this.loginProvider.isUserFraudBlocked()) {
        this.loginProvider.showFraudRestriction = false;
        return this.utilsProvider.redirectToRestrictedTransfers();
      }
    })
  }

  ngOnDestroy() {
    this.loginProvider.isProfileCallNotRequired = false;
    if (this.bridgeVisibleSubscription)
      this.bridgeVisibleSubscription.unsubscribe();
  }

  async initPage() {
    try {
      await this.initializedView;
    } catch (error) {
      LoggerProvider.error(this, LoggerEvent.ConnectionError , 'Error during initialization', error);
    }

    if (this.platform.is('cordova')) this.iterable.enableAutoDisplay();
    await this.init();
    await this.routeProvider.waitForTransitions();

    setTimeout(() => {
      this.checkRemindersAndShow();
    }, 100);
    this.watchBridgeVisibility();
    this.checkMobileTopUpSlide();
  }

  async checkMobileTopUpSlide() {
    try {
      const visible = this.showMessages && await this.dingTopUpProvider.isBannerVisible();
      if (visible !== this.showMobileTopUpSlide) {
        this.showMobileTopUpSlide = visible;
        // Send null, not []: an empty array also removes the Iterable in-app slides.
        await this.updateSlideMessages(null);
      }
      this.trackMobileTopUpSlideDisplayed();
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to check the mobile top-up slide');
    }
  }

  // The bridge can cover this page with any RMT5 route, for example RMT5Home or WalletHome. The customer sees the slide only after the bridge hides.
  trackMobileTopUpSlideDisplayed() {
    if (!this.showMobileTopUpSlide || this.mobileTopUpSlideTracked || VueBridgeState.isUserInsideVueBridge)
      return;
    this.mobileTopUpSlideTracked = true;
    this.analytics.trackEvent({ eventName: AnalyticsEventType.BannerDisplayed, analyticsData: this.getMobileTopUpBannerAnalytics() });
  }

  // The bridge sends false before it clears isUserInsideVueBridge, so read the state after the current task.
  watchBridgeVisibility() {
    if (this.bridgeVisibleSubscription)
      return;
    this.bridgeVisibleSubscription = this.vueProvider.bridgeVisible$.subscribe((visible: boolean) => {
      if (!visible)
        Promise.resolve().then(() => this.trackMobileTopUpSlideDisplayed());
    });
  }

  getMobileTopUpBannerAnalytics() {
    const slides = this.recentData.slidesMessages || [];
    const position = slides.map(slide => slide.id).indexOf(SLIDE_TYPE_ID.SLIDE_MOBILE_TOP_UP) + 1;
    return position > 0 ? { ...DING_TOP_UP_BANNER_ANALYTICS, lineNumber: position } : { ...DING_TOP_UP_BANNER_ANALYTICS };
  }

  dismissMobileTopUpSlide() {
    this.showMobileTopUpSlide = false;
    this.dingTopUpProvider.dismissBanner()
      .catch(ex => LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to save the mobile top-up slide dismissal'));
  }

  openMobileTopUpFromSlide() {
    this.analytics.trackEvent({ eventName: AnalyticsEventType.BannerCtaClicked, analyticsData: this.getMobileTopUpBannerAnalytics() });
    this.dingTopUpProvider.start();
  }

  async checkRemindersAndShow()
  {
    if (AuthProvider.isLoggedIn()) this.checkNpsSurvey();

    const available = await this.authProvider.biometricsAvailable();
    const deviceToken = await this.storageProvider.get(StorageType.FingerprintDeviceToken); // controls isBiometricEnabled
    if (available && (deviceToken == null || deviceToken == undefined)) {
      this.reminderProvider.shouldTriggerReminder(StorageType.ReminderBiometric).then((status) => {
        this.reminderBiometricStatus = status;
        this.updateSlideMessages([]);
        LoggerProvider.info(this, 'Reminders - should Trigger Biometric Reminder', status);
      });
    }else{
      this.reminderBiometricStatus = false;
      this.updateSlideMessages([]);
    }
  }

  async checkNpsSurvey() {
    try {
      if (this.npsSurveyPrompted) return;
      // wait for an in-flight transactions load so the flag below is populated
      if (this.loadingRecentView) await this.loadingRecentView;
      if (!this.customerProvider.isTransactionalNPSNeeded) return;

      this.npsSurveyPrompted = true;
      // small delay of 1 sec so the survey doesn't pop the instant the home page/transactions appears
      setTimeout(() => this.routeProvider.openActionSheet(this.routeProvider.pages.NpsSurveyPage, {}, null), 1000);
    } catch (error) {
      LoggerProvider.error(this, LoggerEvent.ExceptionMessage, 'Failed to show NPS survey', error);
    }
  }

  async openResendUnknowErrorModal() {
    this.navParams.data.resendUnknownError = false;
    this.routeProvider.openActionSheetNew(
      this.routeProvider.pages.ModalAlertPage,
      {
        img: 'assets/icon/yellow-warning-icon.svg',
        title: this.translate.instant('page.errorMessage.ria_errormessage_couldNotProcessHeader'),
        msg: this.translate.instant('page.errorMessage.ria_errormessage_couldNotProcessBody'),
        primaryButtonText: this.translate.instant('global.newTransferBtn'),
        primaryAction: () => {
          // Keep this route pop to avoid action sheet to be open after closing calculator
          this.routeProvider.pop();
          this.routeProvider.openModal(this.routeProvider.pages.CheckPricesPage);
        },
      }
    );
  }

  displayWelcomeMessage() {
    let welcomeTitle;
    const firstName = this.authProvider.getUserFirstName();
    let brand = "Ria";
    if (APP_CONFIG.branding.partnerName) {
      brand = APP_CONFIG.branding.partnerName;
    }

    if (firstName) {
      welcomeTitle = this.translate.instant(
        "page.activityPage.newCustomerHeader",
        { firstName, brand }
      );
    } else if (this.loginProvider.isLiteUser()) {
      // this.showRightProfile = true;
      welcomeTitle = this.translate.instant(
        "page.registrationStartPage.registrationHeader",
        { brand }
      );
    }

    return welcomeTitle;
  }

  displayPromoMessage() {
    let promoTitle;
    const firstName = this.authProvider.getUserFirstName();
    let brand = "Ria";
    if (APP_CONFIG.branding.partnerName) {
      brand = APP_CONFIG.branding.partnerName;
    }
    if (firstName)
      promoTitle = this.translate.instant(
        "page.activityPage.newCustomerHeader",
        { firstName, brand }
      );
    return promoTitle;
  }

  async checkStatusKyc() {
    let forceReload = true;
    if (this.firstKycStatus) forceReload = false;

    let changed = false; // probably can be improved with actually comparing if a change has been done although it might still make sense to check if new inapp messages arrived because of in progress EKYC might trigger new inapp messages
    const kycStatus = await this.loginProvider.getKycStatus(forceReload);
    this.firstKycStatus = false;
    this.isKycInProgress = false;
    if (kycStatus) {
      this.kycAttemtsRemaining =
        kycStatus.attemptsLeft && kycStatus.attemptsLeft > 0;
    }
    if(kycStatus && kycStatus.kycResult == KYC_STATUS.KYC_SUSPECTED) {
      this.suspectedAlertMessage = this.translate.instant('page.activityPage.issueWithIDMessage', {attempts: kycStatus.attemptsLeft});
      this.displaySuspectedAlert = kycStatus.attemptsLeft && kycStatus.attemptsLeft > 0;
      changed = true;
    }
    else if(kycStatus && !kycStatus.isFirstTime) {
      const attempt = kycStatus.attempt;
      if (attempt == KYC_ATTEMPT_STATUS.IN_PROGRESS) {
        this.isKycInProgress = true;
        this.storedOrder = {
          'onfidoId': '',
          'activityDetails': {
            'icon': '',
            'title': `page.activityPage.iDVerificationInProgressHeader`,
            'text': `page.activityPage.iDVerificationInProgressContent`,
            'page': this.routeProvider.pages.OnfidoProgressPage
          }
        };
        await this.checkOnfido();
        changed = true;
      }
    }
    // To make sure we get the correct alert status when showing carousel
    if (changed)
      await this.getAppMessages();
  }

  markHomeTransferCompleted(order: IOrder) {
    if (order && (order.newOrder || order.orderSent) && order.customerId === this.httpProvider.getAuthCustomerId())
      this.homeTransferCompleted = true;
  }

  async loadHomeRevampFlag() {
    try {
      this.homeRevampFlag = (await this.utilsProvider.getFeatureFlagData(FeatureFlagTypes.HomeRevamp)) === true;
    } catch (ex) {
      this.homeRevampFlag = false;
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to read home revamp flag');
    }
  }

  async updateHomeRevampContent() {
    const countryTo = this.order.countryTo || '';
    const countryFrom = this.order.countryFrom || '';
    const t = (key: string, params?: any) => homeTranslate(this.translate, key, params);
    this.heroTitleLead = HomeRevamp.buildHeroTitleLead(t);
    this.heroSubtitleHtml = HomeRevamp.buildHeroSubtitleHtml(t);
    this.homeLocale = HttpProvider.currentLanguage;
    try {
      const country = await this.resourceProvider.getCountryByNameAbbrev(countryTo);
      this.countryToName = country ? country.Name : countryTo;
      const sendCountry = await this.resourceProvider.getCountryByNameAbbrev(countryFrom);
      this.countryFromName = sendCountry ? sendCountry.Name : countryFrom;
    } catch (ex) {
      this.countryToName = countryTo;
      this.countryFromName = countryFrom;
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to resolve home country names');
    }
    this.heroImage = HomeRevamp.resolveHeroImage(countryTo);
    this.homePartners = HomeRevamp.getCorridorPreset(countryTo);
  }

  async resolveFallbackDestination(): Promise<string> {
    try {
      const topCountries = await this.resourceProvider.getTopCountries();
      const sendCountries = await this.resourceProvider.getSendCountries();
      const sendList = (sendCountries || []).filter((country) => !!(country && country.value));
      const sendValues = sendList.map((country) => country.value.toUpperCase());
      const topCountry = (topCountries || []).find((country) => !!(country && country.value) && sendValues.indexOf(country.value.toUpperCase()) >= 0);
      const first = topCountry || sendList[0];
      return first ? first.value.toUpperCase() : null;
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to resolve home fallback destination');
      return null;
    }
  }

  async ionViewWillLoad() {
    // don't use a loader her as it could slow down the user by preventing him from interactions just to display an optional promotional message !
    const homeRevampFlagLoad = this.loadHomeRevampFlag();
    try {
      let countryTo = null;
      const customer: ICustomer = await this.custProvider.getCustomer();
      const countryOfBirth = (customer && customer.countryOfBirth) ? customer.countryOfBirth : '';

      const userSendingCountry = await this.storageProvider.get(StorageType.userSendingCountry);
      const defaultCountry = await this.storageProvider.get(StorageType.DefaultCountryTo);
      await homeRevampFlagLoad;

      // Transactions aren't loaded yet, so only lite users are known to be new here; refreshHomeRevampDestination() switches a full user with no transfers once they are.
      const newUserOrder = this.homeRevampFlag && this.loginProvider.isLiteUser();
      countryTo = HomeRevamp.resolveDestination(newUserOrder, userSendingCountry, defaultCountry, countryOfBirth);
      if (!countryTo && this.homeRevampFlag)
        countryTo = await this.resolveFallbackDestination();

      if (countryTo) {
        this.order.countryTo = countryTo;
        this.order.currencyFrom = APP_CONFIG.region.defaultCurrencyFrom;
        this.order.countryFrom = APP_CONFIG.region.defaultCountryFrom;
        this.order.amountFrom = this.calcProvider.getMinimumAmount(APP_CONFIG.region.defaultCountryFrom); // default amount

        if (!this.homeRevampFlag)
          this.orderProvider.setCurrentOrder(this.order);
      }

      if (this.homeRevampFlag)
        await this.updateHomeRevampContent();
      if (countryTo)
        await this.calculate(this.order);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to get customer');
    }
    await homeRevampFlagLoad;
    if (this.homeRevampFlag && !this.heroTitleLead) {
      this.order.currencyFrom = APP_CONFIG.region.defaultCurrencyFrom;
      this.order.countryFrom = APP_CONFIG.region.defaultCountryFrom;
      await this.updateHomeRevampContent();
    }
    this.welcomeRateInitialized = true;
    if (this.homeEntered && this.homeRevampFlag)
      this.refreshHomeRevampDestination();
  }

  async refreshHomeRevampDestination(force: boolean = false) {
    if (!this.homeRevampFlag || this.hasTransactions || !this.welcomeRateInitialized || this.homeDestinationRefreshing)
      return;
    this.homeDestinationRefreshing = true;
    try {
      if (this.loadingRecentView)
        await this.loadingRecentView;
      if (this.hasTransactions)
        return;
      const defaultCountry = await this.storageProvider.get(StorageType.DefaultCountryTo) || this.order.countryTo;
      const changed = defaultCountry !== this.order.countryTo;
      if (!defaultCountry || (!changed && !force && this.rate && !this.homeRateError))
        return;
      this.zone.run(() => {
        this.homeRateLoading = true;
        this.homeRateError = false;
        if (changed) {
          this.order.countryTo = defaultCountry;
          this.order.currencyTo = null;
          this.rate = null;
          this.ratePromo = null;
          this.isWelcomeRate = false;
          this.resetHomeRateOptions();
        }
      });
      if (!this.order.amountFrom)
        this.order.amountFrom = this.calcProvider.getMinimumAmount(APP_CONFIG.region.defaultCountryFrom);
      await this.updateHomeRevampContent();
      await this.calculate(this.order);
    } catch (ex) {
      this.zone.run(() => this.homeRateError = true);
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to refresh home destination');
    } finally {
      this.zone.run(() => {
        this.homeRateLoading = false;
        this.homeDestinationRefreshing = false;
      });
    }
  }

  ionViewDidLeave() {
    if (this.onfidoTimer)
      window.clearTimeout(this.onfidoTimer);

    this.iterableInAppProvider.clearNotificationTimer();
    this.onfidoTimer = null;
    if(this.ionScrollSubscription)
      this.ionScrollSubscription.unsubscribe();
  }

  rmtViewDidReEnter() {
    this.walletProvider.isSelectingTransaction = false;
    this.markHomeTransferCompleted(this.orderProvider.getCurrentOrder());
    this.checkPendingOrder();
    this.loadingRecentView = null; // set it to false to ensure we always load the latest state (i.e. after placing a cancellation)
    const refreshAfterInit = async () => this.refreshHomeRevampDestination();
    this.initPage().then(refreshAfterInit, refreshAfterInit);
    if (!this.vueProvider.isRmt5HomeActiveBaseLayer()) {
      this.homescreenProvider.trackHomeScreenOrActivityAccessedEvent(
        SegmentLocationNames.Activity, this.hasInAppMessages);
    }
    this.checkProfileCompletionStatus();
  }

  async checkProfileCompletionStatus() {
    try {
      const user = await this.loginProvider.getUserAsync(true);
      if (user && user.IsProfileCompleted != undefined) {
        this.isUserProfileCompleted = user.IsProfileCompleted;
        await this.updateSlideMessages([]);
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to check profile completion status');
    }
  }

  // Template adapter for the US wallet pilot flag (banner *ngIf in activity.html).
  get isWalletSupportEnabled(): boolean {
    return this.walletProvider.isWalletSupportEnabled();
  }

  onOpenRiaAccount() {
    if (!this.isWalletSupportEnabled) return;
    this.vueProvider.navigateWithFreshSession('WalletOnboarding');
  }

  async init() {
    const welcomeRate = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.DIGITAL_WELCOME_RATE_AVAILABLE);
    this.walletEnabled = await this.walletProvider.isEnabled();
    const referAFriendSetting = await UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.ShowReferAFriendCTA);

    if (welcomeRate === '1')
      this.promoAvailable = true;
    else
      this.promoAvailable = false;

    if (referAFriendSetting) {
      await this.loadReferralReward();
      this.referAFriendAvailable = true;
    } else {
      this.referAFriendAvailable = false;
    }

    const appMessagePromise = this.getAppMessages();
    if (!this.loginProvider.isLiteUser()) {
      if (this.showRecentView) {
        const loadingRecentView = this.loadingRecentView;
        if (!loadingRecentView)
          await this.initRecentView(false); // to quickly show the latest transactions
        await this.checkCustomer();

        if (!loadingRecentView) {
          const diff = (new Date().getTime() - this.lastReload) / 1000;
          let seconds = this.utilsProvider.hasFeatureFlagUnsafe(FeatureFlagTypes.TransactionCanChangeDelaySeconds);
          if (!seconds)
            seconds = 60;
          if (diff < seconds && !this.transactionsCanChange)
            LoggerProvider.info(this, `Skip transaction force reload because only ${diff} seconds passed since last reload and transactions should not change soon (change after ${seconds} seconds)`);
          else
            await this.initRecentView(true); // now with force reload to ensure we get the latest data
        }
      } else {
        this.currentPage = 0;
        const page = this.currentPage;
        const transactions = await this.getTransactionsCategories();
        this.allTransactions = [];
        this.newTransaction = null;
        this.inProgressTransactions = [];
        this.otherTransactions = [];
        this.groupTransactions(transactions, page);

        this.checkCustomer();
        // double check if there are more transactions
        if (transactions && transactions.length > 0 && transactions.length < 10)
          this.getMoreTransactions(null);
      }
    }
    if(this.navParams.get("isFromSettings"))
      this.isFromSettings = this.navParams.get("isFromSettings");
    if(!this.isFromSettings){
      this.iterableInAppProvider.checkInAppNotification(this.header);
      await appMessagePromise;
    }
  }

  async checkCustomer() {
    try {
      if(!this.loginProvider.isProfileCallNotRequired) {
        this.loginProvider.isProfileCallNotRequired = true;
        await this.loginProvider.getUserAsync(true);
      }
      this.isCustomerIDInvalid = await this.loginProvider.isCustomerIDInvalid();
      this.isSingpassEnabled = (APP_CONFIG.region.region === Region.SG) ? await this.utilsProvider.isSingpassEnable() : false;

      if (APP_CONFIG.region.region === Region.CL) {
        const kycSetting = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.KYC);
        this.isDigitalIDVerificationCountry = kycSetting === KYC_METHODS.DIGITAL_ID_VERIFICATION;

        if (this.isDigitalIDVerificationCountry) {
          const identityVerification = await this.loginProvider.getIdentityVerificationAsync();
          this.isVeriffVerified = !!(identityVerification && identityVerification.Processor === EKYC_PROCESSOR_TYPE.Veriff &&
            identityVerification.Status === KYC_ATTEMPT_STATUS.VERIFIED);
        }
      }

      if (this.isCustomerIDInvalid)
        ProfileNotificationProvider.addProfileNotification(ProfileNotification.CustomerIDInvalid);
      else
        ProfileNotificationProvider.removeProfileNotification(ProfileNotification.CustomerIDInvalid);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'failed to check customer id')
    }
  }

  async doRefresh(refresher) {

    if (this.loadingRecentView) {
      this.loadingRecentView = null;
    }

    // Complete the pull gesture even if a backend request does not settle.
    let refreshTimeout;
    const timeout = new Promise((resolve, reject) => {
      refreshTimeout = setTimeout(() => {
        reject(new Error('Refresh timeout'));
      }, 10000);
    });

    const refreshInit = (async () => {
      await this.getRecentRate();
      await this.init();
      if (this.homeRevampFlag)
        await this.refreshHomeRevampDestination(true);
    })();

    try {
      // Race between the actual work and the timeout
      await Promise.race([refreshInit, timeout]);
    } catch (error) {
    } finally {
      clearTimeout(refreshTimeout);
      this.heroPullOffset = 0;
      refresher.complete();
    }
  }

  async continueWithTransfer(showLoading: boolean = true){
    // Todo use rmt-modal instead of openActionSheetNew
    this.routeProvider.openActionSheetNew(this.routeProvider.pages.SendContinuePage, {
      order: this.pendingOrder,
    });
  }

  async checkPendingOrder(){
    try {
      this.pendingOrder = await this.orderProvider.getPendingOrder();
      if(this.pendingOrder && this.pendingOrder.recipient && this.pendingOrder.recipient.country.toLowerCase() !== this.pendingOrder.countryTo.toLowerCase()) {
        // empty recipient
        delete this.pendingOrder.recipient
      }
      if (this.pendingOrder) {
        if (this.pendingOrder.orderSent)
          this.pendingOrder = null;
        else if (this.deeplinkProvider.isDeeplinkPendingOrder()) {
          this.deeplinkProvider.setDeeplinkPendingOrder(false);
          await this.continueWithTransfer(false);
        }
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to get pending orders in activites');
    }
    if (!this.pendingOrder)
      this.triggerHomeRateOptions();
  }

  async getTransactionsCategories(forceReload: boolean = true): Promise<any> {
    let promise: any = []
    if(AuthProvider.isLoggedIn()) {
      let viewType = TransactionViewType.Full;
      if (this.showRecentView)
        viewType = TransactionViewType.Condensed;
      promise = this.customerProvider.getTransactionsGroupedByStatus(this.currentPage, null, forceReload, viewType);
    }
    return promise;
  }

  async getRecentTransactionCategories(forceReload: boolean = true): Promise<any> {
    let promise: any = []
    if(AuthProvider.isLoggedIn()) {
      promise = this.customerProvider.getRecentTransactionGroupByStatus(forceReload);
    }
    return promise;
  }

  groupTransactions(transactions: Transaction[], page) {
    let possibleChanges = false;
    let daysTolerance = this.utilsProvider.hasFeatureFlagUnsafe(FeatureFlagTypes.TransactionCanChangeToleranceDays);
    if (!daysTolerance)
      daysTolerance = 20;

    transactions.forEach(transaction => {
      if (transaction.Cancellable) // if it can be cancelled this could still affect the state (i.e. cancellation by user) hence it can change
        possibleChanges = true;
      if (transaction.StatusId !== ORDER_STATUS.EXPIRED && transaction.StatusId !== ORDER_STATUS.COMPLETED && transaction.StatusId !== ORDER_STATUS.CANCELLED && transaction.StatusId !== ORDER_STATUS.REFUNDED) {
        // if the status is an indication that it still could change check how old the transactions is - transactions older than 7 days are not likely to change
        const days = (new Date().getTime() - new Date(transaction.Date).getTime()) / (24*3600*1000);
        if (days <= daysTolerance)
          possibleChanges = true;
      }
      if (this.newOrderNumber && transaction.OrderNo === this.newOrderNumber) {
        this.newTransaction = transaction;
        this.newOrderNumber = null;
      }
      else
        this.allTransactions.push(transaction);
    })
    this.isLoading = false;
    if (transactions.length > 0) // doesn't make sense to go back to hasTransactions = false when we got already transactions once
      this.hasTransactions = true;
    this.recentData.transactions = this.allTransactions;
    // Split in-progress transactions for highlighted section
    this.splitInProgressTransactions();
    // if (page === 0 && this.allTransactions && this.allTransactions.length > 0 && this.allTransactions[0].CountryTo !== this.recentCountry)
    //   this.updateRecentRate(this.allTransactions[0].CountryTo);
    if (page === 0) {
      if (possibleChanges)
        this.transactionsCanChange = true;
      else {
        const skip = this.utilsProvider.hasFeatureFlagUnsafe(FeatureFlagTypes.SkipTransactionCanChangeCheck);
        if (skip)
          LoggerProvider.info(this, `Transaction do not look like they would change but skipping the check (tolerance: ${daysTolerance})`);
        else {
          this.transactionsCanChange = false;
          LoggerProvider.info(this, `Transaction do not look like they would change (tolerance: ${daysTolerance})`);
        }
      }
    }
    this.storeRecentData();
  }

  isInProgressStatus(statusId: ORDER_STATUS): boolean {
    return statusId === ORDER_STATUS.PROCESSING
      || statusId === ORDER_STATUS.PAYMENT_PENDING
      || statusId === ORDER_STATUS.BENEFICIARY_CAN_COLLECT
      || statusId === ORDER_STATUS.PENDING
      || statusId === ORDER_STATUS.UNFUNDED;
  }

  splitInProgressTransactions() {
    const all = this.newTransaction
      ? [this.newTransaction, ...this.allTransactions]
      : this.allTransactions;

    if (!this.useTransferStatusWidgetLayout) {
      this.inProgressTransactions = [];
      this.otherTransactions = all;
      return;
    }

    this.inProgressTransactions = all.filter(t => this.isInProgressStatus(t.StatusId));
    this.otherTransactions = all.filter(t => !this.isInProgressStatus(t.StatusId));
  }

  onSelectTransaction(transaction: Transaction, index = null) {
   if (this.walletProvider.isSelectingTransaction) {
    LoggerProvider.info(this, 'Preventing double tap in Activity page');
    return;
   }
    this.walletProvider.isSelectingTransaction = true;
    this.walletProvider.selectTransaction(transaction, index);
  }

  async getMoreTransactions(scroll: any) {
    this.updateCurrentPage();
    const page = this.currentPage;
    const transactions = await this.getTransactionsCategories();
    this.groupTransactions(transactions, page);
    if (scroll)
      scroll.complete();
  }

  updateCurrentPage() {
    this.currentPage += 1;
  }

  continuePendingOrder() {
    this.routeProvider.openModal(this.routeProvider.pages.CheckPricesPage);
  }

  sendMoney() {
    if (this.loginProvider.isUserFraudBlocked())
      return this.utilsProvider.redirectToRestrictedTransfers();

    this.sendFlowProvider.sendMoneyBtn(true);
  }

  onHomeSendMoney() {
    if (!this.order.countryTo)
      return this.sendMoney();
    if (this.loginProvider.isUserFraudBlocked())
      return this.utilsProvider.redirectToRestrictedTransfers();
    this.sendFlowProvider.sendMoneyBtn(true, this.isWelcomeRate, this.order.countryTo);
  }

  onHomeChangeCountry() {
    if (this.loginProvider.isUserFraudBlocked())
      return this.utilsProvider.redirectToRestrictedTransfers();
    this.sendFlowProvider.showCountryPicker(false, true, this.isWelcomeRate);
  }

  async checkPhoneVerification() {
    const user = await this.loginProvider.getUserAsync();
    if (user && user.RequirePhoneVerification) this.requirePhoneVerification = user.RequirePhoneVerification;
    else this.requirePhoneVerification = false;
  }

  verifyPhone() {
    this.routeProvider.openModal(this.routeProvider.pages.SettingsPersonalPage, {'phoneUp': true, 'allowSamePhone': true});
  }

  async updateExpiredID() {
    if (this.loginProvider.isUserFraudBlocked())
      return this.utilsProvider.redirectToRestrictedTransfers();

    const customer = await this.custProvider.getCustomer();

    if(APP_CONFIG.region.region === Region.SG){
      this.ekycSingPassProvider.userProfileSingpassUpdate()
    } else if (this.onfidoProvider.requireUpdateIdOnStore(customer))
      this.routeProvider.openModal(this.routeProvider.pages.UpdateIdOnStorePage);
    else
      this.navigateIdDetails();
  }

  async dismissVerifyPhone() {
    // no loading needed - can be done in the background
    this.requirePhoneVerification = false;
    try {
      await this.loginProvider.updateCustomerSetting(
        CUSTOMER_SETTINGS.MFA_PREFERENCE.AREA,
        CUSTOMER_SETTINGS.MFA_PREFERENCE.TYPE, 10,
        this.httpProvider.getAuthCustomerId()).toPromise();
    } catch (ex) {
      RmtPopupComponent.showException(this, ex, 'Failed to dismiss verify phone');
    }
  }

  async navigateIdDetails() {
    this.loading.show();
    await this.custProvider.navigateIDDetails(this.onfidoProvider, true, SegmentLocationNames.Carousel);
    this.loading.hide();
  }

  async checkOnfido() {
    if (this.onfidoTimer)
      window.clearTimeout(this.onfidoTimer);
    this.onfidoTimer = null;

    const icon = this.storedOrder.activityDetails.icon;
    this.storedOrder.activityDetails.icon = 'custom-icon-progress';
    try {
      this.onfidoProvider.checkId = this.storedOrder.onfidoId;
      const res = await this.onfidoProvider.getOnfidoStatus(false);
      if (res.Result !== KYC_ATTEMPT_STATUS.IN_PROGRESS) {
        const customer = await this.custProvider.getCustomer();
        this.onfidoFinished = res;
        if (res.Result == KYC_ATTEMPT_STATUS.VERIFIED){
          this.analytics.identifyCustomer(customer, { isEKYC: true });
        } else if (res.Result == KYC_ATTEMPT_STATUS.FAIL) {
          this.analytics.identifyCustomer(customer, { isEKYC: false });
        }
        return;
      }
      else
        this.onfidoFinished = null;
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to get Onfido status in activites'); // TODO improve
      return;
    }
    this.storedOrder.activityDetails.icon = icon;
    this.onfidoTimer = window.setTimeout(() => {
      this.onfidoTimer = null;
      this.checkOnfido();
    }, ConfigProvider.settings.onfidoCheckTimer);
  }

  clickStoredOrder() {
    this.routeProvider.openModal(this.storedOrder.activityDetails.page);
  }

  goToFilter() {
    this.routeProvider.openModal(this.routeProvider.pages.ActivityFilterPage);
  }

  goToActivityAll() {
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.ActivityScreenAccessed,
      analyticsData: {
        location: SegmentLocationNames.HomeScreen
    }});
    this.routeProvider.openModal(this.routeProvider.pages.ActivityAllPage);
  }

  goToRecipientsAll() {
    if (UtilsProvider.tabs)
      UtilsProvider.tabs.selectTab(this.routeProvider.pages.RecipientListPage);
    else
      LoggerProvider.info(this, 'Unable to select recipient tab');
  }

  async clickOnfido() {
    if (this.onfidoFinished){
      this.storedOrder = await this.orderProvider.getStoredOrder();
      this.onfidoProvider.handleResult(this.onfidoFinished, this.storedOrder);
    }
    else
      this.routeProvider.openModal(this.routeProvider.pages.OnfidoNotVerifiedPageNonSMF);
  }

  async goToOnfido() {
    this.onfidoProvider.openOnfidoFlow(true, SegmentLocationNames.Activity, true);
  }

  closePopup(){
    this.isShowActivateWalletPopup = false;
    this.walletProvider.hideWalletPopup();
    RmtPopupComponent.showToastWithPointDown(this.translate.instant('page.activityPage.activateWalletReminder'));
  }
  closeNonFPXPopup(){
    this.isShowNonFPXPopup=false;
    this.walletProvider.hideNonFPXPopup();
  }

  async goToActivateWallet(fromCreateProfile: boolean = false) {
    if (this.loginProvider.isLiteUser()) {
      this.onCompleteProfileClick(true);
    } else {
      const locationFrom = fromCreateProfile ? "Create Profile" : "Activity";
      this.walletProvider.setIsWalletActivateFromSMF(false);
      this.walletProvider.setIsFromCreateProfile(fromCreateProfile);
      this.walletProvider.getWalletActivate(locationFrom);
    }
  }

  async loadActivateWalletPopup(){
    this.isShowActivateWalletPopup = await this.walletProvider.isShowActivateWalletPopup();
  }

  async loadNonFPXPopup(){
    this.isShowNonFPXPopup = await this.walletProvider.isNonFPXPopup();
  }

  async checkReferralFlow() {
    // TODO !!!!!!!!!!!!!!!!!!!!!!!!! not needed at the moment hence disabled to avoid unnecessary call
    /*
    const promo = await this.authProvider.hasReferralPromo();
    if(promo) {
      if(promo.PromoId === PROMOTION_TYPE.CUSTOMERREFERRAL) {
        let showReferralModal: any = this.deeplinkProvider.getDeepLinkShowReferralParam();
        if (!showReferralModal && !this.hasTransactions && !this.storedOrder)
          showReferralModal = true;
        if (showReferralModal)
          this.showModalReferralPage(promo);
      }
      else this.showModalRewardPage(promo);
    }
    this.deeplinkProvider.setDeepLinkShowReferralParam(null);
    */
  }

  async showModalReferralPage(promotion) {
    this.canShowModalReferralPage = false;
    const customer = await this.loginProvider.getCustomerAsync();
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant("page.promotionsPage.rAFSuccessHeader", {firstName: customer.FirstName}),
        subtitle: this.translate.instant("page.promotionsPage.rAFSuccessBody"),
        primaryButtonText: this.translate.instant('page.promotionsPage.rAFSendMoneyButton'),
        secondaryButtonText: this.translate.instant('global.notNowButton'),
        showSecondaryButton: true,
        primaryAction: () => this.redirectToCheckPrices(promotion),
      },
      null
    );
  }

  showModalRewardPage(promotion) {
    this.canShowModalReferralPage = false;
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant("page.activityPage.rafModal.rewardAvailableAlert"),
        subtitle: this.translate.instant("page.activityPage.rafModal.zeroTransferFeeBody"),
        primaryButtonText: this.translate.instant('page.promotionsPage.rAFSendMoneyButton'),
        secondaryButtonText: this.translate.instant('global.notNowButton'),
        showSecondaryButton: true,
        primaryAction: () => this.redirectToCheckPrices(promotion)
      },
      null
    );
  }

  redirectToCheckPrices(promotion) {
    this.routeProvider.push(this.routeProvider.pages.CheckPricesPage, { promotion: promotion})
  }

  getFormattedDate(time) {
    const date = new Date(time);
    return this.utilsProvider.getFormattedActivityTransactionDate(date.toString());
  }

  async checkPlaidPostedAccount() {
    if (!this.loginProvider.isLiteUser()) {
      // TODO !!!!!!!!!!!!!!!!!!!!! IMPROVE - currently Plaid is only used in US hence it only makes sense for US to check it
      if (APP_CONFIG.region.defaultCountryFrom === 'US') {
        if (await this.paymentProvider.hasPostedAccounts())
          this.addProfileNotification();
      }
      if (this.deepLinkData && this.deepLinkData.message == 'plaid-account-posted' && this.deepLinkData.accountId) {
        DeeplinkProvider.deepLinkData = null;
        this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, {
          title: this.translate.instant('page.bankVerificationPage.verifyBankTitle'),
          image: "assets/imgs/bank.svg",
          subtitle: this.translate.instant('page.bankVerificationPage.verifyBankText'),
          primaryButtonText: this.translate.instant('page.bankVerificationPage.verifyNowButton'),
          primaryAction: () => this.startPlaid(),
          showSecondaryButton: true,
          secondaryButtonText: this.translate.instant('page.bankVerificationPage.verifyLaterButton')
        }, null);
      }
      else if (this.deepLinkData && !this.deepLinkData.accountId) {
        LoggerProvider.info(this,'Deeplink is missing accountId', this.deepLinkData);
      }
    }
  }

  startPlaid() {
    if (this.deepLinkData && this.deepLinkData.accountId) {
      this.loadingProvider.show();
      this.paymentProvider.getAccountById(parseInt(this.deepLinkData.accountId)).then(
        bank => {
          this.loadingProvider.hide();
          this.plaidProvider.plaidNative({ bank: bank, onContinue: ()=> {
              RmtSnackbarComponent.present(this.translate.instant('page.activityPage.bankVerifiedSuccessMessage'));
            }, verifyAgain: true
          });

        }
      ).catch(
        () => this.loadingProvider.hide()
      )
    }
  }

  addProfileNotification() {
    ProfileNotificationProvider.addProfileNotification(ProfileNotification.PlaidAccountPosted);
  }

  async onCompleteProfileClick(gotoActivateWallet: boolean = false) {
    const enableEkycSingpass = await this.utilsProvider.isSingpassRegistrationEnable();
    this.rmt5VueBridgeSettings = await UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeSettings);
    if(APP_CONFIG.region.region == Region.SG && enableEkycSingpass){
      this.routeProvider.openModal(this.routeProvider.pages.SingpassProfileVerifyMethodSelectPage, { pageLoadFrom: EKYC_PAGEFROM.REGISTER, location: location });
    } else if(this.rmt5VueBridgeSettings) {
      this.vueProvider.navigate('CompleteProfileInfo', '', {}, () => {
        // Fallback to in-app flow if Vue navigation fails
        console.log('Vue navigation failed, falling back to in-app flow');
        VueBridgeState.isUserInsideVueBridge = false;
        this.utilsProvider.logCreateProfileStartedEvent(
          AnalyticsProfileCreationStartedLocations.Notification
        );
        this.routeProvider.openModal(this.routeProvider.pages.RlDynamicFieldsPage, {
          location: AnalyticsProfileCreationStartedLocations.Notification,
          onContinue: () => {
            if (gotoActivateWallet) this.goToActivateWallet(true);
            else this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);
          },
        });
      }, true); // Show loading while bridge connects
    } else {
      this.utilsProvider.logCreateProfileStartedEvent(
        AnalyticsProfileCreationStartedLocations.Notification
      );
      this.routeProvider.openModal(this.routeProvider.pages.RlDynamicFieldsPage, {
        location: AnalyticsProfileCreationStartedLocations.Notification,
        onContinue: () => {
          if (gotoActivateWallet) this.goToActivateWallet(true);
          else this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);
        },
      });
    }
  }

  async onReferAFriend(){
    this.routeProvider.openModal(this.routeProvider.pages.ReferAFriendNewPage, {analyticsLocation: 'Activity' });
  }

  openProfile() {
    this.routeProvider.openModal(this.routeProvider.pages.SettingsPage);
  }

  openHeroTerms() {
    this.routeProvider.openIab(this.translate.instant('global.linkTermsURLWithToken').replace('{{locale}}', HomeRevamp.resolveLocale(HttpProvider.currentLanguage)));
  }

  updateHeroInitials() {
    const customerRecord = this.user && this.user.Customers && this.user.Customers.length ? this.user.Customers[0] : null;
    this.heroInitials = (this.loginProvider.isLiteUser() || !customerRecord) ? '' : HomeRevamp.initials(customerRecord.FirstName, customerRecord.FirstLastName);
  }

  ngAfterViewChecked() {
    const hidden = this.homeRevampActive;
    if (hidden === this.homeRevampHeaderHidden)
      return;
    this.homeRevampHeaderHidden = hidden;
    if (this.content)
      this.content.resize();
  }

  private async loadReferralReward() {
    try {
      const response = await this.socialProvider.getReferralCodeNew();
      if (response && response.Value && response.Value.ReferralAmount != null) {
        const symbol = getCurrencySymbol(APP_CONFIG.region.defaultCurrencyFrom, 'narrow');
        const amount = this.currencyFormatter.transform(response.Value.ReferralAmount, APP_CONFIG.region.defaultCurrencyFrom, false, false, NumberFormatter.getRegionLocale());
        this.referralReward = `${symbol}${amount}`;
      } else {
        this.referralReward = "";
      }
    } catch (exception) {
      this.referralReward = "";
      LoggerProvider.exception(this, exception, LoggerEvent.ReferaFriend, "Failed to load referral reward for home pill");
    }
  }

  onScroll(scrollInfo: any) {
    if (!this.header || !this.header.appbar)
      return;
    this.header.appbar.canSwitchToSmallReferralBtn = scrollInfo.scrollTop > 0;
  }

  clickCloseSlide(slide: any) {
    if(slide.isClosable && slide.closeAction) {
      slide.closeAction();
    }

    if(slide.id == SLIDE_TYPE_ID.SLIDE_BIOMETRIC_REMINDER){
      this.hideBiometricReminderSetupAlert()
    }

    if (slide.id === SLIDE_TYPE_ID.SLIDE_MOBILE_TOP_UP)
      this.dismissMobileTopUpSlide();

    this.storeRecentData();
  }

  showSlidesMessages() {
    return this.showMessages && this.recentData.slidesMessages && this.recentData.slidesMessages.length > 0 && !this.animLoadingSlide;
  }

  showSlidesRecipients() {
    return !this.animLoading && !this.animLoadingSlide && this.showRecentView && this.recentData.slidesRecipients && this.recentData.slidesRecipients.length > 0;
  }

  touchSlides() {
    if (this.homeRevampActive)
      return;
    this.lockedScroll = true;
  }

  finishTouch() {
    this.lockedScroll = false;
    this.heroPullOffset = 0;
  }

  onHeroTouchCancel() {
    if (this.homeRevampActive)
      this.heroPullOffset = 0;
  }

  onHeroPull(refresher: any) {
    if (!this.homeRevampActive) {
      this.heroPullOffset = 0;
      return;
    }
    this.heroPullOffset = refresher && refresher.deltaY > 0 ? HomeRevamp.dampPull(refresher.deltaY) : 0;
  }

  async initRecentView(forceReload: boolean = false, firstInit: boolean = false) {
    if (this.loadingRecentView) {
      // also ignore force reload
      LoggerProvider.info(this, 'Recent view loading already in progress');
      return;
    }

    let loadingResolve;
    this.loadingRecentView = new Promise((resolve) => { loadingResolve = resolve; });

    try {
      LoggerProvider.info(this, 'Init recent view');

      const page = this.currentPage;
      const transactionsPromise = this.getTransactionsCategories(forceReload);
      const recipientsPromise = this.getRecentTransactionCategories(forceReload);

      if (firstInit) {
        await this.getRecentDataFromCache();
      }

      const transactions = await this.fetchTransactions(transactionsPromise);

      this.allTransactions = [];
      this.newTransaction = null;
      this.groupTransactions(transactions, page);
      // if (!this.hasTransactions) {
        // this.showRecentView = false;
      // }
      this.animLoading = false;
      this.triggerHomeRateOptions();

      if (transactions.length === 0) {
        this.animLoadingSlide = false;
        return;
      }

      let recentRecipients = null;
      if (recipientsPromise) {
        try {
          const recipients = await this.fetchRecipients(recipientsPromise);
          recentRecipients = recipients && recipients.recentRecipients ? recipients.recentRecipients : [];
        } catch (ex) {
          LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to load recent recipients');
          recentRecipients = this.getFallbackRecentRecipients(transactions);
        }
      } else {
        LoggerProvider.info(this, 'Do not use recent recipient endpoint');
        recentRecipients = this.getFallbackRecentRecipients(transactions);
      }

      // Add timeout to prevent infinite waiting for translations
      const translationTimeout = new Promise((resolve) => {
        setTimeout(() => {
          resolve(null);
        }, 1000);
      });
      await Promise.race([this.httpProvider.isTranslationReady(), translationTimeout]);

      const slides = this.buildRecipientSlides(transactions, recentRecipients);
      this.updateSlides(slides);
      // await this.getAppMessages();

      if (forceReload || !this.lastReload)
        this.lastReload = new Date().getTime();

      this.animLoadingSlide = false;
      this.storeRecentData();

    } catch (error) {
      RmtPopupComponent.showException(this, error, 'Failed to load recent data');
    } finally {
      loadingResolve(true);
      this.loadingRecentView = null;
      if (forceReload || !this.recentDataTime)
        this.recentDataTime = new Date().getTime();
    }
  }

  fetchTransactions(transactionsPromise: Promise<any>): Promise<any> {
    try {
      return transactionsPromise;
    } catch (ex) {
      throw new Error("Failed to fetch transactions");
    }
  }

  private async fetchRecipients(recipientsPromise: Promise<any>): Promise<any> {
    try {
      return await recipientsPromise;
    } catch (error) {
      throw new Error('Failed to fetch recipients');
    }
  }

  private handleEmptyTransactions(): void {
    this.animLoadingSlide = false;
    this.showRecentView = false;
    this.animLoading = false;
  }

  private buildRecipientSlides(transactions: any[], recipients: any): any[] {
    const slides: any[] = [];

    for (let recipient of recipients) {
      const image = this.orderProvider.getDeliveryMethodImage(recipient.lastDeliveryMethod);
      const trx = transactions.find(item => item.BenNameId === recipient.id);
      const subtitle = this.getDeliveryMethodForRecentTransactions(recipient, trx);
      slides.push({
        id: recipient.id,
        title: recipient.firstName,
        title2: recipient.lastName1,
        subtitle,
        skipRightImage: true,
        topImage: image,
        countryIcon: recipient.country,
        isLoadingSubtitle: false
      });
    }


    return slides;
  }

  private updateSlides(slides: any[]): void {
    if (this.checkUpdateSlides(this.recentData.slidesRecipients, slides)) {
      this.recentData.slidesRecipients = slides;
      if (this.slidesRecipientsComponent)
        this.slidesRecipientsComponent.updateSwiper();
    }
  }

  async getRecentDataFromCache() {
    try {
      const recentDataStr = await this.storageProvider.get(StorageType.RecentData);
      if (recentDataStr) {
        const recentData = JSON.parse(recentDataStr);
        if (recentData) {
          if (recentData.userId === this.httpProvider.getAuthUserId()) {
            LoggerProvider.info(this, 'Found cached recent data');
            // Fix for method definitions for pending actions not being serializable
            if (recentData.slidesMessages)
              this.recentData.slidesMessages = recentData.slidesMessages.filter(message => {
                return this.checkIfMessageIsValid(message);
              }
              );
            if (recentData.slidesRecipients) {
              this.recentData.slidesRecipients = recentData.slidesRecipients;
              this.recentData.slidesRecipients.forEach((trx) => { trx.isLoadingSubtitle = true; });
            }
            if (recentData.transactions) {
              recentData.transactions.forEach((trx) => { trx.IsLoading = true; });
              this.recentData.transactions = recentData.transactions;
              this.allTransactions = this.recentData.transactions;
              if (this.allTransactions.length > 0) {
                LoggerProvider.info(this, 'Show cached recent data');
                this.hasTransactions = true;
                this.animLoading = false;
                this.animLoadingSlide = false;
              }
            }
          }
          else
            LoggerProvider.info(this, 'Found cached recent data but for different user ' + recentData.userId + ' <=> ' + this.httpProvider.getAuthUserId());
        }
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to get stored recent data');
    }
  }

  checkIfMessageIsValid(message) {
    if (message && message.id) {
      switch (message.id) {
        case SLIDE_TYPE_ID.SLIDE_FPX_TRX:
          return this.isShowNonFPXPopup;
        case SLIDE_TYPE_ID.SLIDE_CUSTOMER_ID_INVALID:
          return this.isCustomerIDInvalid && this.kycAttemtsRemaining && this.isIdExpiredAlertAllowedSg;
        case SLIDE_TYPE_ID.SLIDE_COMPLETE_PROFILE:
          return !this.isUserProfileCompleted;
        case SLIDE_TYPE_ID.SLIDE_REQUIRE_PHONE_VERIFICATION:
          return this.requirePhoneVerification;
        case SLIDE_TYPE_ID.SLIDE_STORED_ORDER:
          return (this.storedOrder && this.storedOrder.activityDetails && !this.onfidoFinished);
        case SLIDE_TYPE_ID.SLIDE_ID_VERIFICATION:
          return (this.storedOrder && this.storedOrder.activityDetails && this.onfidoFinished);
        case SLIDE_TYPE_ID.SLIDE_ACTIVATE_WALLET:
          return this.isShowActivateWalletPopup;
        case SLIDE_TYPE_ID.TRANSFERS_RESTRICTED:
          return this.loginProvider.isUserFraudBlocked();
        case SLIDE_TYPE_ID.SLIDE_BIOMETRIC_REMINDER:
          return this.reminderBiometricStatus;
        case SLIDE_TYPE_ID.SLIDE_MOBILE_TOP_UP:
          return this.showMobileTopUpSlide;
        default:
          return false;
      }
    }
    return true;
  }

  getDeliveryMethodForRecentTransactions(recipient: any, trx: Transaction) {
    let subtitle = ''
    const recipientFuncParam = {recipient: recipient};
    subtitle = this.recipientProvider.getRecipientText(recipientFuncParam, this.orderProvider, trx, true);
    if (!subtitle) {
      if (trx && trx.IsOpenCountry)
        subtitle = this.translate.instant('ActivityPage.OpenCountryLabel');
      else
        subtitle = recipient.city;
    }
    return subtitle;
  }

  async clickRecipient(slide) {
    if (this.loginProvider.isUserFraudBlocked())
      return this.utilsProvider.redirectToRestrictedTransfers();

    this.loadingProvider.show();
    try {
      const recipient = await this.recipientProvider.getRecipient(slide.id);
      this.loadingProvider.hide();

      this.orderProvider.setCurrentOrder(null);
      this.sendFlowProvider.fireRecipientSelectedEvent(recipient, false, SegmentLocationNames.HomeScreen, slide.lineNumber);
      const params = {
        recipient,
        sendFromRecipient: true,
      }
      this.routeProvider.openModal(this.routeProvider.pages.CheckPricesPage, params);
    } catch (ex) {
      this.loadingProvider.hide();
      RmtPopupComponent.showException(this, ex, 'Failed to open recipient');
    }
  }

  storeRecentData() {
    try {
      if (this.showRecentView) {
        this.recentData.userId = this.httpProvider.getAuthUserId();
        this.storageProvider.set(StorageType.RecentData, JSON.stringify(this.recentData));
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to store recent data');
    }
  }

  checkUpdateSlides(initialSlides, slides) {
    // only update slides if data has changed otherwise we trigger the animations all the time
    return (JSON.stringify(initialSlides) !== JSON.stringify(slides));
  }

  getCountryIcon(value) {
    if (value)
      return 'assets/countryFlagSvg/' + value.toUpperCase() + '.svg';
    return '';
  }

  processSlideActionButton(slide) {
    if (slide.id && slide.actionButton) {
      switch (slide.id) {
        case SLIDE_TYPE_ID.SLIDE_ACTIVATE_WALLET:
          this.goToActivateWallet();
          break;
        case SLIDE_TYPE_ID.SLIDE_FPX_TRX:
          this.sendMoney();
          break;
        case SLIDE_TYPE_ID.SLIDE_REQUIRE_PHONE_VERIFICATION:
          this.verifyPhone();
          break;
        case SLIDE_TYPE_ID.SLIDE_STORED_ORDER:
          this.clickStoredOrder();
          break;
        case SLIDE_TYPE_ID.SLIDE_ID_VERIFICATION:
          this.clickOnfido();
          break;
        case SLIDE_TYPE_ID.SLIDE_COMPLETE_PROFILE:
          this.onCompleteProfileClick();
          break;
        case SLIDE_TYPE_ID.SLIDE_CUSTOMER_ID_INVALID:
          this.updateExpiredID();
          break;
        case SLIDE_TYPE_ID.TRANSFERS_RESTRICTED:
          this.routeProvider.openModal(this.routeProvider.pages.ReEnableTransfersPage);
          break;
          case SLIDE_TYPE_ID.SLIDE_BIOMETRIC_REMINDER:
            this.displayBiometricReminderSetupAlert()
            break;
        case SLIDE_TYPE_ID.SLIDE_MOBILE_TOP_UP:
          this.openMobileTopUpFromSlide();
          break;
      }
    }
  }

  displayBiometricReminderSetupAlert() {
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        image: 'assets/imgs/biometric-alert-header.svg',
        title: this.translate.instant('page.biometricsModal.title'),
        subtitle: this.translate.instant('page.biometricsModal.body'),
        primaryButtonText: this.translate.instant('global.genericContinueButton'),
        showPrimaryButton: true,
        showSecondaryButton: true,
        dismissFromPrimary: true,
        secondaryButtonText: this.translate.instant('global.dismissButton'),
        showFullPage: false,
        isModal: true,
        hideHeader: true,
        primaryButtonAction: (_, modal) => {
          modal.viewCtrl.dismiss().then(()=>{
            return this.authProvider.enableBiometrics(this.translate).then((value: any) => {
              if(value && value.enabled && value.enabled=== true){
                this.reminderBiometricStatus = false;
                this.reminderProvider.removeReminder(StorageType.ReminderBiometric);
              }
            });
          });
        },
      }, null
    );
  }

  hideBiometricReminderSetupAlert() {
    this.reminderBiometricStatus = false;
    this.reminderProvider.extendReminder(StorageType.ReminderBiometric);
  }


  getFallbackRecentRecipients(transactions) {
    const recipientIds = {};

    const recipients = [];
    for (const trx of transactions) {
      if (recipients.length >= 3)
        break;

      if (trx && trx.BenNameId && !recipientIds[trx.BenNameId]) {
        const recipient = {
          id: trx.BenNameId,
          lastDeliveryMethod: OrderMapper.mapOrderDeliveryMethod(trx),
          bankAccountNumber: trx.BankAccountNo ? this.orderProvider.getMaskAccountNumber(trx.BankAccountNo) : '',
          mobileWalletAccountNo: trx.mobile,
          city: trx.PayCity,
          firstName: trx.BeneficiaryFirstName,
          lastName1: trx.BeneficiaryFirstLastName,
          country: trx.CountryTo
        };
        recipients.push(recipient);
        recipientIds[trx.BenNameId] = recipient;
      }
    }
    return recipients;
  }

  async getRecentRate() {
    try {
      // RBE-2683: Lite users don't have a customerId in their auth token (only ReservedCustomerId),
      // and the LastTransactionRate API requires a valid customerId. Skip for lite users.
      if (this.loginProvider.isLiteUser()) {
        LoggerProvider.info(this, LoggerEvent.ActivityPage, 'Skipping getRecentRate - Lite user does not have customerId');
        return;
      }
      if (!this.isWalletCountry) {
        const res = await this.customerProvider.getCustomerRecentRate();
        if (res && res.CurrentRate && res.LastTransactionCountryTo && res.LastTransactionCurrencyFrom && res.LastTransactionCurrencyTo) {
          if (res.LastTransactionCurrencyFrom === res.LastTransactionCurrencyTo) {
            this.showRecentRate = false;
            this.loadingRate = true;
            return;
          } else {
            this.showRecentRate = true;
            this.loadingRate = false;
            this.rateLastTransactionCountryTo = res.LastTransactionCountryTo;
            this.rateLastTransactionCurrencyFrom = res.LastTransactionCurrencyFrom;
            this.rateLastTransactionCurrencyTo = res.LastTransactionCurrencyTo;
            this.currentRate = PriceCalculatorProvider.updateRate(res.CurrentRate);
          }
        } else {
          this.showRecentRate = false;
          this.loadingRate = true;
        }
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, "Recent rate api call fail");
      this.showRecentRate = false;
      this.loadingRate = false;
    }
  }

  displayRecentRateModal() {
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        image: 'assets/imgs/info_logo_carousel_new.svg',
        title: this.translate.instant('page.Homescreen.rateAlertTitle'),
        subtitle: this.translate.instant('page.Homescreen.rateAlertBody'),
        primaryButtonText: this.translate.instant('global.gotItButton'),
        showPrimaryButton: true,
        showSecondaryButton: false,
        showFullPage: false,
        isModal: true,
        hideHeader: true,
      }, null
    );
  }

  isUserVerified(user){
    return (user.IdentityVerification && user.IdentityVerification.Status === KYC_ATTEMPT_STATUS.VERIFIED);
  }

  async calculate(order: IOrder) {
    if (this.homeRevampFlag)
      return this.calculateHomeRate(order);
    try {
      const totals = await this.calcProvider.calculateOrderTotals(this.resourceProvider, order, null, false);
      this.rate = totals.exchangeRate;
      if (totals.currencies && totals.currencies.length > 0) {
        this.order.currencyTo = totals.currencies[0].currencyCode;

      }
      if (totals.exchangeRatePromo) {
        this.ratePromo = totals.exchangeRatePromo;
      } else if (totals.calculatedRatePromo) {
        this.ratePromo = totals.calculatedRatePromo;
      }
      this.isWelcomeRate = this.ratePromo ? true : false;

    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to calculate order');
    }
  }

  private async calculateHomeRate(order: IOrder) {
    const seq = this.resetHomeRateOptions();
    const request: IOrder = { ...order };
    let timeout;
    this.zone.run(() => {
      this.homeRateLoading = true;
      this.homeRateError = false;
    });
    try {
      const totals: any = await Promise.race([
        this.homeRateCalculator.calculateOrderTotals(this.resourceProvider, request, null, false),
        new Promise((resolve, reject) => {
          timeout = setTimeout(() => reject(new Error('Home rate request timed out')), 15000);
        }),
      ]);
      if (seq !== this.homeRateOptionsSeq || this.order.countryTo !== request.countryTo)
        return;
      if (!totals || !(totals.exchangeRate || totals.exchangeRatePromo || totals.calculatedRatePromo))
        throw new Error('Home rate response has no rate');
      this.zone.run(() => {
        this.rate = totals.exchangeRate;
        const currencies = totals.currencies || [];
        const selected = currencies.find(currency => currency.currencyCode === request.currencyTo);
        const currency = selected || currencies.find(currency => currency.isDefaultCurrency) || currencies[0];
        this.order.currencyTo = currency ? currency.currencyCode : request.currencyTo;
        this.ratePromo = totals.exchangeRatePromo || totals.calculatedRatePromo || null;
        this.isWelcomeRate = !!this.ratePromo;
        this.homeRatePrimarySeq = seq;
        this.triggerHomeRateOptions();
      });
    } catch (ex) {
      if (seq === this.homeRateOptionsSeq) {
        this.zone.run(() => {
          this.rate = null;
          this.ratePromo = null;
          this.isWelcomeRate = false;
          this.homeRateError = true;
        });
      }
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to calculate home rate');
    } finally {
      clearTimeout(timeout);
      if (seq === this.homeRateOptionsSeq)
        this.zone.run(() => this.homeRateLoading = false);
    }
  }

  resetHomeRateOptions(): number {
    this.homeRateOptions = [];
    this.homeRateOptionsSeq += 1;
    return this.homeRateOptionsSeq;
  }

  triggerHomeRateOptions() {
    const seq = this.homeRateOptionsSeq;
    if (!this.homeRevampActive || this.pendingOrder || this.homeRatePrimarySeq !== seq || this.homeRateOptionsRequestedSeq === seq)
      return;
    this.homeRateOptionsRequestedSeq = seq;
    this.loadHomeRateOptions(this.order, seq);
  }

  async loadHomeRateOptions(order: IOrder, seq: number) {
    if (seq !== this.homeRateOptionsSeq || !this.homeRevampActive || this.pendingOrder)
      return;
    const baseOrder: IOrder = { ...order };
    const countryTo = baseOrder.countryTo;
    const primaryCurrency = this.order.currencyTo;
    const primaryRate = this.isWelcomeRate && this.ratePromo ? this.ratePromo : this.rate;
    if (!countryTo || !primaryCurrency || !primaryRate)
      return;
    const extraCurrencies = (await this.getHomeDestinationCurrencies(countryTo)).filter((currency) => !!currency && currency !== primaryCurrency);
    if (!extraCurrencies.length || seq !== this.homeRateOptionsSeq || !this.homeRevampActive)
      return;
    const extras = await Promise.all(extraCurrencies.map(async (currency) => this.calculateHomeRateOption(baseOrder, currency, this.isWelcomeRate)));
    if (seq !== this.homeRateOptionsSeq || this.order.countryTo !== countryTo)
      return;
    this.zone.run(() => this.homeRateOptions = [{ currency: primaryCurrency, rate: primaryRate }].concat(extras.filter((option) => !!option)));
  }

  async getHomeDestinationCurrencies(countryTo: string): Promise<string[]> {
    try {
      const sendCountries = await this.resourceProvider.getSendCountries();
      const match = (sendCountries || []).find((country) => !!(country && country.value) && country.value.toUpperCase() === countryTo.toUpperCase());
      return match && match.availableCurrencies ? match.availableCurrencies : [];
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to read home destination currencies');
      return [];
    }
  }

  async calculateHomeRateOption(order: IOrder, currency: string, promo: boolean): Promise<IHomeRateOption> {
    try {
      const totals = await this.homeRateCalculator.calculateOrderTotals(this.resourceProvider, { ...order, currencyTo: currency }, null, false);
      const rate = !totals ? null : promo ? (totals.exchangeRatePromo || totals.calculatedRatePromo) : totals.exchangeRate;
      return rate ? { currency, rate } : null;
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to calculate home rate option');
      return null;
    }
  }
}

export interface ItransGroup {
  [key: string]: Transaction[];
}



// WEBPACK FOOTER //
// ./src/pages/activity/activity.ts